import { mockLabelA } from './mockLabelA'
import { mockLabelB } from './mockLabelB'
import { MOCK_LABEL_A_ID, MOCK_LABEL_B_ID } from './mockLabelsConstants'
import { Labels } from 'firebaseFunctions/types'

export const mockLabels: Labels = {
  [MOCK_LABEL_A_ID]: mockLabelA,
  [MOCK_LABEL_B_ID]: mockLabelB,
}
